const strings = {
  Edge: 'Edge'
}

export default strings
